import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { fieldClass } from './TextField';
type SelectFieldProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  name: string;
  options: string[];
  placeholder?: string;
  error?: string;
};
export function SelectField({
  label,
  name,
  options,
  placeholder = 'Select…',
  error,
  required,
  className = '',
  ...rest
}: SelectFieldProps) {
  const id = `field-${name}`;
  return <div className={className} data-id="element-59" data-mp="vi4bwu9wpjxu">
      <label htmlFor={id} className="font-slab text-xs font-bold uppercase tracking-[0.2em]" data-id="element-60" data-mp="rhlkv2fu8hwp">
        {label}
        {required && <span className="text-ink-muted" data-id="element-61" data-mp="mhfzu542ptnl"> *</span>}
      </label>
      <div className="relative" data-id="element-62" data-mp="hj4r5xpilp6y">
        <select id={id} name={name} required={required} aria-invalid={!!error} className={`${fieldClass} appearance-none pr-10 ${error ? 'border-red-400' : ''}`} defaultValue="" {...rest} data-id="element-63" data-mp="hjxne4qukwau">
          <option value="" disabled data-id="element-64" data-mp="3eszw9h0chrrv">
            {placeholder}
          </option>
          {options.map(o => <option key={o} value={o} data-id="element-65" data-mp="3iv3a2cahl8gb">
              {o}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 mt-1 h-4 w-4 -translate-y-1/2 text-ink-muted" aria-hidden="true" data-id="element-66" data-mp="34vlhdlu2lb1o" />
      </div>
      {error && <p className="mt-1.5 text-xs text-red-300" data-id="element-67" data-mp="2v50mo9hioqo1">{error}</p>}
    </div>;
}